import { createIcon } from '../../../ImageIcon';

export const IconLoading = createIcon(require('./loading.png'), 40 / 60);
export const IconPrimaryLoading = createIcon(
  require('./primaryLoading.png'),
  40 / 60,
);
